module.exports = __webpack_public_path__ + "img/player.8a7e725b.jpg";